import { useAtom } from 'jotai';
import React, { useEffect, useMemo } from 'react';
import { matchingAtom } from '../shared/MatchingFields';

const useGlobalMatchingField = (MatchingFields) => {
  const [, setMatching] = useAtom(matchingAtom);
  useEffect(() => {
    setMatching(MatchingFields);
  }, [MatchingFields]);
};

export default useGlobalMatchingField;
